(()=>{
  function init(root){
    if(!root||root.dataset.cnReady||typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return;
    root.dataset.cnReady='true';
    root.querySelector('[data-cn-search-fallback]').hidden=true;
    root.querySelectorAll('[data-cn-open]').forEach(button=>{
      button.hidden=false;
      button.addEventListener('click',()=>{
        const dialog=document.getElementById(button.dataset.cnOpen);
        if(!dialog||dialog.open)return;
        root.querySelectorAll('details[open]').forEach(detail=>detail.open=false);
        dialog.showModal();dialog.dataset.opener=button.dataset.cnOpen;
        const field=dialog.querySelector('input[type="search"]');
        if(field)field.focus();
        dialog.addEventListener('close',()=>button.focus(),{once:true});
      });
    });
    root.querySelector('[data-cn-menu-fallback]').hidden=true;
    root.querySelectorAll('dialog').forEach(dialog=>{
      dialog.querySelectorAll('[data-cn-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
      dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
    });
    const explore=root.querySelector('.cn-explore');
    document.addEventListener('click',event=>{if(explore?.open&&!explore.contains(event.target))explore.open=false;});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&explore?.open){explore.open=false;explore.querySelector('summary').focus();}});
  }
  document.querySelectorAll('[data-campaign-shell]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-campaign-shell]').forEach(init));
})();
